import { Box, Container } from "src/components/MuiGenerals";
import TableTab from "src/components/TableTab";
import PageConfigProvider, {
  usePageConfigProviderContext,
} from "src/features/PageConfigProvider";
import { customSx } from "src/utils/styling";
import useSorting from "./hooks/useSorting";
import useTableColumns from "./hooks/useTableColumns";
import useTableRows from "./hooks/useTableRows";
import { GetListRes } from "./types/GetListRes";

const ViewFilterTable = () => {
  const { list } = usePageConfigProviderContext();

  //! returned list is not ApiResult<T> from getPendingSummary
  //! force to change the type of list to GetListRes[]
  //! update if returned data may change to ApiResult<T> in futrue
  const localList =
    list.rows?.length === 0 ? [] : (list as any as GetListRes[]);

  const { columns } = useTableColumns();
  const { rows } = useTableRows({ apiList: localList });
  const { sortedRows } = useSorting({ rows });

  return (
    <Box sx={customSx.layoutBox}>
      <Container
        style={customSx.datagridContainer}
        maxWidth={false}
        disableGutters>
        <TableTab>
          <PageConfigProvider.DataGrid
            columns={columns}
            rows={sortedRows}
            //! could be removed if list type in api changed to ApiResult<T>
            rowCount={localList.length}
            componentsProps={{
              footer: { totalRecords: localList.length },
            }}
          />
        </TableTab>
      </Container>
    </Box>
  );
};

export default ViewFilterTable;
